var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValidated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.625,
    height: 31.625,
    viewBox: "0 0 31.625 31.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3063d5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.8,17.353a.9.9,0,0,1,0,1.266l-7.318,7.318a.891.891,0,0,1-1.264,0l-3.73-3.73a.895.895,0,1,1,1.266-1.266l3.1,3.095,6.686-6.685a.9.9,0,0,1,1.264,0Zm9.657,4.292A15.813,15.813,0,1,1,21.645,5.832,15.83,15.83,0,0,1,37.457,21.645Zm-1.79,0A14.023,14.023,0,1,0,21.645,35.667,14.037,14.037,0,0,0,35.667,21.645Z",
    transform: "translate(-5.832 -5.832)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidated);
export default __webpack_public_path__ + "static/media/validated.c42c4229a1ecd48b1cd8eea6319e5066.svg";
export { ForwardRef as ReactComponent };